import React from "react";
import { Outlet,useLocation } from "react-router-dom";

import Tabs from "../../../components/common/Tabs";

const tabs = [
  {
    link: "/communication/letters_templates/templates",
    title: "Templates",
  },
  {
    link: "/communication/letters_templates/mailing_services",
    title: "Mailing Service",
  },
];

function Letters() {
  const location = useLocation();
  console.log(location.pathname)
  return (
    <>
    {location.pathname === "/communication/letters_templates/send_owner_packets" ? 
      <Outlet /> : 

      <><Tabs tabs={tabs} /><Outlet /></>
  }
    </>
  );
}

export default Letters;
